import React, { JSX } from 'react';
import { EditableArea } from '@magnolia/react-editor';
import { MgnlContent } from '@magnolia/frontend-helpers-base';
import { PageProps } from '@/Util/magnolia';

const Accordion = (props: { accordionArea?: MgnlContent; pageProps: PageProps }): JSX.Element => {
  const { accordionArea } = props;

  return (
    <div className="accordion">
      {accordionArea ? <EditableArea content={accordionArea} /> : <></>}
    </div>
  );
};

export default Accordion;
